import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessProductPriceTier } from '@barboxx/models';

interface Props {
    businessProductPriceTier: BusinessProductPriceTier.DetailsResponse;
}

export const BusinessProductPriceTierDeleteCard = ({
    businessProductPriceTier,
}: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteBusinessProductPriceTier = useMutation({
        mutationKey: [
            'deleteBusinessProductPriceTier',
            businessProductPriceTier.id,
        ],
        mutationFn: () =>
            Api.BusinessSpecific.ProductPriceTier.deleteProductPriceTier(
                businessProductPriceTier
            ),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this product price tier!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Product Price Tier',
            }
        );

        if (!deleteConfirmed) {
            return;
        }
        mutateDeleteBusinessProductPriceTier
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted product price tier!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting product price tier!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Business Product Price Tier" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this menu item?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
